import './App.css';
import MessageList from "./components/MessageList";
import "./styles/root.css"
import FamilyList from './components/FamilyList';
import { getUserRole, login, logout } from "./services/authService";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import UserList from "./components/UserList";
import MessageDetail from './components/MessageDetail';
import FamilyDetail from './components/FamilyDetail';
import UserDetail from './components/UserDetail';

const App = () => {
  const role = getUserRole();
  const isAuthenticated = !!localStorage.getItem("accessToken");

  return (
    <Router>
      <div className="container mx-auto mt-5">
        {isAuthenticated ? (
          <>
            <nav className="flex justify-between bg-blue-500 text-white p-3 mb-4 nav-header">
              <a href="/messages" className="px-4 py-2">Manage Messages</a>
              <a href="/family" className="px-4 py-2">Manage Families</a>
              {role === "SuperAdmin" && (
                <a href="/register" className="px-4 py-2">Register User</a>
              )}
              <a
                href="/login"
                onClick={() => localStorage.clear()}
                className="logout-button"
              >
                Logout
              </a>
            </nav>

            <Routes>
              <Route path="/" element={<Navigate to="/messages" />} />
              <Route path="/messages" element={<MessageList />} />
              <Route path="/messages/:id" element={<MessageDetail />} />
              <Route path="/family/:id" element={<FamilyDetail />} />
              <Route path="/family" element={<FamilyList />} />
              {role === "SuperAdmin" && (
                <>
                  <Route path="/register" element={<UserList />} />
                  <Route path="/register/:id" element={<UserDetail />} />
                </>
              )}
              <Route path="*" element={<h1>404 - Not Found</h1>} />
            </Routes>
          </>
        ) : (
          <Routes>
            <Route path="/login" element={<LoginForm />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        )}
      </div>
    </Router>
  );
};

export default App;
